import React from "react";
import classNames from "classnames/bind";
import styles from "./Editor.module.scss";

import { Editor } from "@toast-ui/react-editor";
import "@toast-ui/editor/toastui-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";
import "@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css";
import colorSyntax from "@toast-ui/editor-plugin-color-syntax";

const cx = classNames.bind(styles);

export default function CustomEditor({
  title,
  name,
  placeholder,
  editorRef,
  initialValue,
  handleEditorChange,
  handleEditorImageUpload,
}) {
  return (
    <div className={cx("textarea-box")}>
      {title && <label className={cx("label")}>{title}</label>}
      <Editor
        ref={editorRef}
        initialValue={initialValue}
        plugins={[colorSyntax]}
        initialEditType="wysiwyg"
        height="100%"
        autofocus={false}
        placeholder={placeholder}
        onChange={() =>
          handleEditorChange(
            name,
            editorRef.current?.getInstance().getMarkdown()
          )
        }
        hooks={{
          addImageBlobHook: (blob, callback) =>
            handleEditorImageUpload(blob, callback),
        }}
      />
    </div>
  );
}
